import { render, staticRenderFns } from "./CompanyProducts.vue?vue&type=template&id=4c531ef0"
import script from "./CompanyProducts.vue?vue&type=script&lang=js"
export * from "./CompanyProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports